import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./CheckBox.scss";
import Icon from "../Icons/Icons";

// We have a different icon for checkbox, so we need to use a different component
export default function CheckBox({
  className = "",
  defaultChecked = false,
  onClick = () => {},
  ...props
}) {
  const [checked, setChecked] = useState(defaultChecked);
  const onCheck = () => {
    const currentValue = !checked;
    onClick(currentValue);
    setChecked(currentValue);
  };
  return (
    <div className={`check-box ${className}`} {...props} onClick={onCheck}>
      {checked ? <Icon.checkbox_filled /> : <Icon.checkbox_unfilled />}
    </div>
  );
}
